export const REQUEST_STATUS = 'REQUEST_STATUS';
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_SAVING_STATUS = 'SET_SAVING_STATUS';
export const SET_OPEN = 'SET_OPEN';
export const SET_SAVING_OPEN = 'SET_SAVING_OPEN';
export const CLEAR_STATUS = 'CLEAR_STATUS';
export const HTTP_SUCCESS = 200;
export const SHOW_MENU_ITEMS = "SHOW_MENU_ITEMS";
export const HIDE_MENU_ITEMS = "HIDE_MENU_ITEMS";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
export const HIDE_ERROR_MESSAGE = "HIDE_ERROR_MESSAGE";

export const SHOW_LICENSE_DIALOG = "SHOW_LICENSE_DIALOG";
export const HIDE_LICENSE_DIALOG = "HIDE_LICENSE_DIALOG";